var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "27.52 44.19 446.75 427.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.74,249.37H338.53a3.15,3.15,0,0,0-3.15,3.15v4.19a3.15,3.15,0,0,0,3.15,3.15h6.75l2.36,4.08,2.35-4.08h6.75a3.15,3.15,0,0,0,3.15-3.15v-4.19A3.15,3.15,0,0,0,356.74,249.37Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1668926417879113px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.79,271.12h-18.2a3.15,3.15,0,0,0-3.15,3.14v4.2a3.15,3.15,0,0,0,3.15,3.14h6.74l2.36,4.08,2.36-4.08h6.74a3.15,3.15,0,0,0,3.15-3.14v-4.2A3.15,3.15,0,0,0,315.79,271.12Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1668926417879113px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.65,231.9H378.44a3.15,3.15,0,0,0-3.15,3.15v4.19a3.14,3.14,0,0,0,3.15,3.14h6.75l2.35,4.08,2.36-4.08h6.75a3.14,3.14,0,0,0,3.15-3.14v-4.19A3.15,3.15,0,0,0,396.65,231.9Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1668926417879113px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435,249.1h-18.2a3.15,3.15,0,0,0-3.15,3.15v4.19a3.14,3.14,0,0,0,3.15,3.14h6.74l2.36,4.08,2.36-4.08H435a3.15,3.15,0,0,0,3.16-3.14v-4.19A3.16,3.16,0,0,0,435,249.1Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1668926417879113px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.67,288.6s.66,12.64,1.33,15.95,3.34,15.13,4.35,25.57a85.42,85.42,0,0,0,3,16s8.09,31.42,8.57-8.05c.17-13.92-1.33-35.8-1.33-35.8l.66-6.63",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.83,294.83s-6.8,1.43-9.13,6.74-2.65,17.57-2.32,20.88a57.81,57.81,0,0,1,0,8l9.3-3",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.05,312.18s-21.92,12.26-22.92,14.25-21.58,64-21.91,68.29,16.27,20.55,16.27,20.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-8--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.68,234.94s-9.63,5.63-10.29,13.92a51.24,51.24,0,0,0,1.66,16.24s-3-2.65-3.32,3.32,4.65,10.6,6.64,10.6h2s4.43,9.1,9.75,13.41,10.51,4.5,14.16,3.17,10.63-7.29,11.3-15.25,0-21.22-.67-29.5-2.32-14.26-11.29-17.24S225.33,232.61,220.68,234.94Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.48,91.69s-24.21-44.8-76.09-47.41-70.34,50.51-108.14,71c-19.79,10.74-59.81-7.24-80.92-1.09C84.84,133.88,60.75,224,89.79,271.59c25.13,41.26,68.48,60.19,134,59.93s111.54,2,169.46-45.34S445.84,150.88,417.48,91.69Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.48,91.69s-24.21-44.8-76.09-47.41-70.34,50.51-108.14,71c-19.79,10.74-59.81-7.24-80.92-1.09C84.84,133.88,60.75,224,89.79,271.59c25.13,41.26,68.48,60.19,134,59.93s111.54,2,169.46-45.34S445.84,150.88,417.48,91.69Z",
    style: {
      fill: "#fff",
      opacity: 0.800000011920929,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-4--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 254.85,
    y: 99.49,
    width: 28.31,
    height: 6.52,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.85,
    y: 108.91,
    width: 18.6,
    height: 6.52,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.85,
    y: 118.33,
    width: 10.71,
    height: 6.52,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 254.85,
    y: 99.49,
    width: 28.31,
    height: 6.52
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 254.85,
    y: 108.91,
    width: 18.6,
    height: 6.52
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 254.85,
    y: 118.33,
    width: 10.71,
    height: 6.52
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 200.67,
    y: 176.7,
    width: 19.63,
    height: 9.6,
    transform: "translate(28.99 391.99) rotate(-90)",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.91,
    y: 180.07,
    width: 12.89,
    height: 9.6,
    transform: "translate(39.49 409.23) rotate(-90)",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.52,
    y: 182.8,
    width: 7.42,
    height: 9.6,
    transform: "translate(50.62 425.83) rotate(-90)",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 200.67,
    y: 176.7,
    width: 19.63,
    height: 9.6,
    transform: "translate(28.99 391.99) rotate(-90)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 217.91,
    y: 180.07,
    width: 12.89,
    height: 9.6,
    transform: "translate(39.49 409.23) rotate(-90)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 234.52,
    y: 182.8,
    width: 7.42,
    height: 9.6,
    transform: "translate(50.62 425.83) rotate(-90)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M203.54,205.64H319.79a11.58,11.58,0,0,0,11.6-11.58V98.26a11.58,11.58,0,0,0-11.6-11.58H203.54a11.59,11.59,0,0,0-11.6,11.58v95.8A11.59,11.59,0,0,0,203.54,205.64Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.84,
    y1: 172.75,
    x2: 318.29,
    y2: 172.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.84,
    y1: 177.18,
    x2: 318.29,
    y2: 177.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.84,
    y1: 181.61,
    x2: 318.29,
    y2: 181.61,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.84,
    y1: 186.05,
    x2: 318.29,
    y2: 186.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.84,
    y1: 190.48,
    x2: 318.29,
    y2: 190.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 204.42,
    y1: 100.46,
    x2: 245.87,
    y2: 100.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 204.42,
    y1: 104.89,
    x2: 245.87,
    y2: 104.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 204.42,
    y1: 109.32,
    x2: 245.87,
    y2: 109.32,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 204.42,
    y1: 113.75,
    x2: 245.87,
    y2: 113.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 204.42,
    y1: 118.19,
    x2: 245.87,
    y2: 118.19,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.1,135.3l7.9,4.15-.89-22.28-18.88,11.91,7.9,4.14-5.94,11.31h0a4.76,4.76,0,0,0-2.9,1l-10.46-4.86s0,0,0,0a4.82,4.82,0,0,0-9.64,0,4.75,4.75,0,0,0,.44,2l-13.71,14.86a4.6,4.6,0,0,0-1.35-.22,5.2,5.2,0,0,0-.69.07l-19.71-24.91a4.75,4.75,0,0,0,.42-2,4.82,4.82,0,0,0-9.64,0,5,5,0,0,0,.25,1.46l-22.51,22.92a4.93,4.93,0,0,0-1.65-.3,4.81,4.81,0,1,0,4.82,4.81,4.6,4.6,0,0,0-.16-1.18L239.4,135a4.79,4.79,0,0,0,1.37.22,5,5,0,0,0,.88-.08L261.26,160a4.82,4.82,0,1,0,8.88.62l14.06-15.23a5.29,5.29,0,0,0,.81.08,4.77,4.77,0,0,0,2.68-.82l10.7,5a4.81,4.81,0,1,0,8.76-3Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-3--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "165.37 157.19 151.85 136.06 129.51 152.49 108.91 111.72 54.55 146.28 54.55 174.2 177.13 174.2 177.13 150.73 165.37 157.19",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1606299289794355px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.72 173.03 153.03 150.73 128.34 160.71 99.53 133.13 54.55 151.29 54.55 191.81 177.13 191.81 177.13 166.57 167.72 173.03",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.8766012586124072px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.72 173.03 153.03 150.73 128.34 160.71 99.53 133.13 54.55 151.29 54.55 191.81 177.13 191.81 177.13 166.57 167.72 173.03",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.72 173.03 153.03 150.73 128.34 160.71 99.53 133.13 54.55 151.29 54.55 191.81 177.13 191.81 177.13 166.57 167.72 173.03",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.8766012586124072px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.2,101.38h-9.87a2.67,2.67,0,0,0-1.21,5.06l-3.45,3.67,6.29-3.37h8.24a2.68,2.68,0,0,0,0-5.36Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.2,101.38h-9.87a2.67,2.67,0,0,0-1.21,5.06l-3.45,3.67,6.29-3.37h8.24a2.68,2.68,0,0,0,0-5.36Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.43,125.24h-9.87a2.67,2.67,0,0,0-1.21,5.06L152.9,134l6.29-3.38h8.24a2.68,2.68,0,0,0,0-5.36Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.43,125.24h-9.87a2.67,2.67,0,0,0-1.21,5.06L152.9,134l6.29-3.38h8.24a2.68,2.68,0,0,0,0-5.36Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5,205.64H175.75a11.58,11.58,0,0,0,11.6-11.58V98.26a11.58,11.58,0,0,0-11.6-11.58H59.5A11.58,11.58,0,0,0,47.9,98.26v95.8A11.58,11.58,0,0,0,59.5,205.64Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.73,
    y1: 99.61,
    x2: 64.74,
    y2: 99.61,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.73,
    y1: 108.33,
    x2: 64.74,
    y2: 108.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.73,
    y1: 117.05,
    x2: 64.74,
    y2: 117.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.73,
    y1: 125.77,
    x2: 64.74,
    y2: 125.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.73,
    y1: 134.49,
    x2: 64.74,
    y2: 134.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.32,111.43a26.34,26.34,0,1,0,26.38,26.34A26.38,26.38,0,0,0,371.32,111.43Zm0,44.94A18.61,18.61,0,1,1,390,137.77,18.64,18.64,0,0,1,371.32,156.37Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M371.32,111.43a26.34,26.34,0,1,0,26.38,26.34A26.38,26.38,0,0,0,371.32,111.43Zm0,44.94A18.61,18.61,0,1,1,390,137.77,18.64,18.64,0,0,1,371.32,156.37Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M371.32,111.43a26.34,26.34,0,1,0,26.38,26.34A26.38,26.38,0,0,0,371.32,111.43Zm0,44.94A18.61,18.61,0,1,1,390,137.77,18.64,18.64,0,0,1,371.32,156.37Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.32,111.43a26.18,26.18,0,0,0-19.05,8.11l5.59,5.35a18.62,18.62,0,1,1,13.46,31.48v7.73a26.34,26.34,0,1,0,0-52.67Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.38,111.43a26.34,26.34,0,1,0,26.38,26.34A26.38,26.38,0,0,0,436.38,111.43Zm0,44.94A18.61,18.61,0,1,1,455,137.77,18.65,18.65,0,0,1,436.38,156.37Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M436.38,111.43a26.34,26.34,0,1,0,26.38,26.34A26.38,26.38,0,0,0,436.38,111.43Zm0,44.94A18.61,18.61,0,1,1,455,137.77,18.65,18.65,0,0,1,436.38,156.37Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M436.38,111.43a26.34,26.34,0,1,0,26.38,26.34A26.38,26.38,0,0,0,436.38,111.43Zm0,44.94A18.61,18.61,0,1,1,455,137.77,18.65,18.65,0,0,1,436.38,156.37Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.65,113.5l-3,7.12a18.61,18.61,0,0,1-7.26,35.75v7.73a26.33,26.33,0,0,0,10.27-50.6Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.32,86.68H350.62a14.41,14.41,0,0,0-14.42,14.4v90.17a14.41,14.41,0,0,0,14.42,14.39h108.7a14.4,14.4,0,0,0,14.42-14.39V101.08A14.41,14.41,0,0,0,459.32,86.68Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.88,
    y1: 172.75,
    x2: 389.32,
    y2: 172.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.88,
    y1: 177.18,
    x2: 389.32,
    y2: 177.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.88,
    y1: 181.61,
    x2: 389.32,
    y2: 181.61,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.88,
    y1: 186.05,
    x2: 389.32,
    y2: 186.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.88,
    y1: 190.48,
    x2: 389.32,
    y2: 190.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.32,
    y1: 172.75,
    x2: 457.77,
    y2: 172.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.32,
    y1: 177.18,
    x2: 457.77,
    y2: 177.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.32,
    y1: 181.61,
    x2: 457.77,
    y2: 181.61,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.32,
    y1: 186.05,
    x2: 457.77,
    y2: 186.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.32,
    y1: 190.48,
    x2: 457.77,
    y2: 190.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 382.86,
    y1: 98.89,
    x2: 424.3,
    y2: 98.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 382.86,
    y1: 103.33,
    x2: 424.3,
    y2: 103.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.76,372.34H458.44a15.29,15.29,0,0,0,15.3-15.27V227.86a15.29,15.29,0,0,0-15.3-15.28H277.24a15.29,15.29,0,0,0-15.3,15.28V313",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.1,
    y: 287.93,
    width: 29.18,
    height: 42.41,
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1606299289794355px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.1,
    y: 287.93,
    width: 29.18,
    height: 42.41,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.1,
    y: 287.93,
    width: 29.18,
    height: 42.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1606299289794355px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.62,
    y: 266.72,
    width: 29.18,
    height: 46.95,
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1606299289794355px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.62,
    y: 266.72,
    width: 29.18,
    height: 46.95,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.62,
    y: 266.72,
    width: 29.18,
    height: 46.95,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1606299289794355px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.14,
    y: 249.31,
    width: 29.18,
    height: 31.05,
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1606299289794355px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.14,
    y: 249.31,
    width: 29.18,
    height: 31.05,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.14,
    y: 249.31,
    width: 29.18,
    height: 31.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1606299289794355px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.1,
    y: 330.33,
    width: 29.18,
    height: 17.42,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1606299289794355px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.62,
    y: 313.67,
    width: 29.18,
    height: 34.08,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1606299289794355px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.27,
    y: 266.72,
    width: 29.18,
    height: 46.95,
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1606299289794355px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.27,
    y: 266.72,
    width: 29.18,
    height: 46.95,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.27,
    y: 266.72,
    width: 29.18,
    height: 46.95,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1606299289794355px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.27,
    y: 313.67,
    width: 29.18,
    height: 34.08,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1606299289794355px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.14,
    y: 280.35,
    width: 29.18,
    height: 67.4,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1606299289794355px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.74,249.37H338.53a3.15,3.15,0,0,0-3.15,3.15v4.19a3.15,3.15,0,0,0,3.15,3.15h6.75l2.36,4.08,2.35-4.08h6.75a3.15,3.15,0,0,0,3.15-3.15v-4.19A3.15,3.15,0,0,0,356.74,249.37Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.74,249.37H338.53a3.15,3.15,0,0,0-3.15,3.15v4.19a3.15,3.15,0,0,0,3.15,3.15h6.75l2.36,4.08,2.35-4.08h6.75a3.15,3.15,0,0,0,3.15-3.15v-4.19A3.15,3.15,0,0,0,356.74,249.37Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M356.74,249.37H338.53a3.15,3.15,0,0,0-3.15,3.15v4.19a3.15,3.15,0,0,0,3.15,3.15h6.75l2.36,4.08,2.35-4.08h6.75a3.15,3.15,0,0,0,3.15-3.15v-4.19A3.15,3.15,0,0,0,356.74,249.37Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1668926417879113px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.79,271.12h-18.2a3.15,3.15,0,0,0-3.15,3.14v4.2a3.15,3.15,0,0,0,3.15,3.14h6.74l2.36,4.08,2.36-4.08h6.74a3.15,3.15,0,0,0,3.15-3.14v-4.2A3.15,3.15,0,0,0,315.79,271.12Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.79,271.12h-18.2a3.15,3.15,0,0,0-3.15,3.14v4.2a3.15,3.15,0,0,0,3.15,3.14h6.74l2.36,4.08,2.36-4.08h6.74a3.15,3.15,0,0,0,3.15-3.14v-4.2A3.15,3.15,0,0,0,315.79,271.12Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M315.79,271.12h-18.2a3.15,3.15,0,0,0-3.15,3.14v4.2a3.15,3.15,0,0,0,3.15,3.14h6.74l2.36,4.08,2.36-4.08h6.74a3.15,3.15,0,0,0,3.15-3.14v-4.2A3.15,3.15,0,0,0,315.79,271.12Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1668926417879113px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.65,231.9H378.44a3.15,3.15,0,0,0-3.15,3.15v4.19a3.14,3.14,0,0,0,3.15,3.14h6.75l2.35,4.08,2.36-4.08h6.75a3.14,3.14,0,0,0,3.15-3.14v-4.19A3.15,3.15,0,0,0,396.65,231.9Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.65,231.9H378.44a3.15,3.15,0,0,0-3.15,3.15v4.19a3.14,3.14,0,0,0,3.15,3.14h6.75l2.35,4.08,2.36-4.08h6.75a3.14,3.14,0,0,0,3.15-3.14v-4.19A3.15,3.15,0,0,0,396.65,231.9Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M396.65,231.9H378.44a3.15,3.15,0,0,0-3.15,3.15v4.19a3.14,3.14,0,0,0,3.15,3.14h6.75l2.35,4.08,2.36-4.08h6.75a3.14,3.14,0,0,0,3.15-3.14v-4.19A3.15,3.15,0,0,0,396.65,231.9Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1668926417879113px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,249.1h-18.2a3.15,3.15,0,0,0-3.15,3.15v4.19a3.14,3.14,0,0,0,3.15,3.14h6.74l2.36,4.08,2.36-4.08H435a3.15,3.15,0,0,0,3.16-3.14v-4.19A3.16,3.16,0,0,0,435,249.1Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435,249.1h-18.2a3.15,3.15,0,0,0-3.15,3.15v4.19a3.14,3.14,0,0,0,3.15,3.14h6.74l2.36,4.08,2.36-4.08H435a3.15,3.15,0,0,0,3.16-3.14v-4.19A3.16,3.16,0,0,0,435,249.1Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M435,249.1h-18.2a3.15,3.15,0,0,0-3.15,3.15v4.19a3.14,3.14,0,0,0,3.15,3.14h6.74l2.36,4.08,2.36-4.08H435a3.15,3.15,0,0,0,3.16-3.14v-4.19A3.16,3.16,0,0,0,435,249.1Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1668926417879113px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.09,
    y1: 225.94,
    x2: 334.54,
    y2: 225.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.09,
    y1: 230.37,
    x2: 334.54,
    y2: 230.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.09,
    y1: 234.81,
    x2: 334.54,
    y2: 234.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.09,
    y1: 239.24,
    x2: 334.54,
    y2: 239.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.09,
    y1: 243.67,
    x2: 334.54,
    y2: 243.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0630963744082347px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.68,296.63c-.55.66-1.11,1.36-1.71,2.16-7.44,10-3.56,31-8.08,38.75s-15.84,5.53-18.1,17.71-1,24.9-2.91,31-9.37,10-10.67,17.16-1.69,12.35-1.69,12.35l43.16-1.42Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.68,296.63c-.55.66-1.11,1.36-1.71,2.16-7.44,10-3.56,31-8.08,38.75s-15.84,5.53-18.1,17.71-1,24.9-2.91,31-9.37,10-10.67,17.16-1.69,12.35-1.69,12.35l43.16-1.42Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "224.16 414.79 179.84 419.91 193.45 432.51 224.01 429.86",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.29,
    y1: 421.92,
    x2: 222.68,
    y2: 418.82,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48492790893308585px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.51,
    y1: 425.02,
    x2: 222.24,
    y2: 422.81,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48492790893308585px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 199.17,
    y1: 427.68,
    x2: 222.68,
    y2: 425.46,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48492790893308585px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.12,
    y1: 420.1,
    x2: 205.21,
    y2: 428.92,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48492790893308585px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 203.11,
    y1: 419.81,
    x2: 211.15,
    y2: 428.12,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48492790893308585px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 209.33,
    y1: 418.92,
    x2: 217.36,
    y2: 427.23,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48492790893308585px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.98,
    y1: 418.48,
    x2: 222.68,
    y2: 425.46,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48492790893308585px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.84,309.85c-1.46-.62-8.22-26.93-8.22-26.93L167.14,273s-5.23-17.85-7.23-21.17-10-6-10-6l-3-1.65-13-7v.07l-1.87-3.91-22.38-18s.4,4.34,1,8.62c-.06,0-4.66,3-6.3,5.63-.31.49-.58,1.54-1.82,4.29-5,2.58-23.83,12.45-30.06,17.26-7.31,5.63-8.64,9.61-8.31,12.93l.34,5.3s3.12,19,6.37,28.37l-.4-.19-.11,116.62L164,410.62l.15-86.63c3.2-1.05,6.53-2.28,8.54-3.17l.5.45,4.22,3.09a5.49,5.49,0,0,0,4.81.89c1.79-.51.67-2.63-.63-3.33a24,24,0,0,1-2.8-2.21l-3.9-4.86c2.34.42,6.09,1.08,7.65,1.3,2.32.33,5.31,1,5.64-2S181.17,310.85,178.84,309.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.77,215.38s1.27,14.1,2.1,16.64c.75,2.3,4.54,14.85,7.86,20.48s7.37,5,8-1.32.31-16.57.31-16.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.53,224.29s-4.41,2.69-6.07,5.34-8.64,27.18-8.64,27.18l13.28.67-11.29,5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.15,265.43S109.44,284,111.1,286a23.09,23.09,0,0,1,2.65,4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.43,230s5.64,23.21,9,35.47S127,293,127,293",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,237.26s1.33,26.85,1.33,37.46v16.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "132.68 234.6 141.65 252.84 134.34 255.16 145.63 261.45 135.34 293.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.01,
    y1: 237.26,
    x2: 146.96,
    y2: 244.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.26,
    y1: 264.44,
    x2: 158.92,
    y2: 295.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.46,233.94s-22.58,11.6-29.88,17.24-8.64,9.61-8.31,12.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.58,
    y1: 297.59,
    x2: 70.58,
    y2: 413.61,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.03,
    y1: 326.1,
    x2: 129.03,
    y2: 409.31,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.69,262.46s7.62,2.67,11,9.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.64,262.08s6.86,2.67,9.91,9.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "79.07 368.57 104.35 368.57 104.35 373.53 79.97 373.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.55,287.3c-2.38-6-4.37-11-5.41-14.29a14.68,14.68,0,0,1-4.29,10.78c-6.9,6.74-8.85,4.4-8.54,13.76s4,13.61,1.69,21.59S143.64,335,144,348.82a19.28,19.28,0,0,0,2.46,8.63L104.84,413l59.52-1.75V331.78Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.55,287.3c-2.38-6-4.37-11-5.41-14.29a14.68,14.68,0,0,1-4.29,10.78c-6.9,6.74-8.85,4.4-8.54,13.76s4,13.61,1.69,21.59S143.64,335,144,348.82a19.28,19.28,0,0,0,2.46,8.63L104.84,413l59.52-1.75V331.78Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.41,
    y1: 373.28,
    x2: 164.41,
    y2: 407.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,187.86c2-.33,11.95-6.63,10.29-12.93S139.66,161,128.7,164.66a52.4,52.4,0,0,0-17.94,10.27s-7.3,0-10,3-.66,7.62,1,10.94c1.44,2.87,1.38,10.48,1.34,12.45a.48.48,0,0,0-.26.06,4.52,4.52,0,0,0-2.22,2.94c-.45,2,.38,4.67,2.4,7.69a7.91,7.91,0,0,0,6.48,3.87h0a12.7,12.7,0,0,1,2.09,3.34c.84,2,9.21,14.84,14,15.21.69.06,1.35.08,2,.08,4.13,0,7.13-1.11,8.74-3.25,2.13-2.83,7.41-14.24,8.07-19.79.11-1,.17-2.25.2-3.75a5.3,5.3,0,0,0,0-6.57c-.11-5.87-.42-11.95-.5-13.35A2,2,0,0,0,145,187.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.64,187.53s1,18.23.33,23.87-6,16.9-8,19.56-6,3.31-10.29,3-12.62-12.6-13.62-14.92a12.37,12.37,0,0,0-2.32-3.64s-3.65.33-6.31-3.65-3.65-8-.33-9.95",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.36,205.43s2.33-4,4.65-1.66l1.66,10.61-5,1.33.66,5.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.38,
    cy: 205.43,
    rx: 4.98,
    ry: 4.97,
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.38,
    cy: 205.43,
    rx: 4.98,
    ry: 4.97,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1668926417879113px",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.3,204.44a5,5,0,1,0-5,5A5,5,0,0,0,145.3,204.44Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.3,204.44a5,5,0,1,0-5,5A5,5,0,0,0,145.3,204.44Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1668926417879113px",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 119.4,
    y1: 205.43,
    x2: 109.44,
    y2: 206.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.48,198.52s2.67-2.66,7.63-1.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.26,197s5-2.66,6.48.76",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.42,188.19s2.66,6.3,3.32,7.3-3.32,5.63-3.32,5.63v4.64l-4,.33-4-3.64-2.32-.67s.33-9.61-1.33-12.92-3.65-8-1-10.94,10-3,10-3a52.4,52.4,0,0,1,17.94-10.27c11-3.65,24.9,4,26.56,10.27S147,187.53,145,187.86s-5-3.64-8-3.64h-4.65c-3.32,0-3.65-.34-7.31-.34S113.42,188.19,113.42,188.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.58,182.75s5.67-3.14,8.51-8.49-6.62-2.83-9.14.63,3.47,2.2,3.47,2.2",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48492790893308585px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.42,188.19s-3.4,3.68-7.81,4",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48492790893308585px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.06,192.82s-6,2.83-9.14,2.83",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48492790893308585px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.92,198.16s4.73,1,7.25,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48492790893308585px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.62,183.38s2.52-.31,10.71-3.14,11-6,5.67-10.07",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48492790893308585px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.22,361.16s-13.05-34.71-16.4-38.05-20.14-13.57-20.14-13.57l-1.35-2.31-.82-2.81s-1-4.23-3.88-6.32l-.23-.49-19.8-8.48s.14,2.62.35,5.78c-2.34.85-7.53,3.13-9.31,7.19-1.16,2.63-1.82,7-2.15,11.11l-.81.6.3-1.1S191.06,325,190.07,327c-1.28,1.68-4.59,12.45-4.59,12.45s-3.3,10.35-6.93,21.78c-5.12,15.72-10.07,31.43-10.39,33.94,0,.23,0,.12,0,.12-.33,4.31,16.13,20.2,16.13,20.2l.22,0,2,2s0-.2,0-.83c1.39,2.83,3.66,7,5.46,6.12,1.48-.73,1-3.3-.2-6.65,1.49,2.27,3.2,3.92,4.56,3.26,2.35-1.16,1.18-5.17-1.18-10.91a3.61,3.61,0,0,0-2.26-2.07c.76-.08,1.53-.16,2.32-.26.79,3.67,2.56,6.85,4.55,6.43s2.29-3,1.89-7.39c.2,0,.47-.59.67-.62.88,3.09,2.23,5.84,3.93,5.48,1.87-.4,2.38-2.26,2.16-6,0-1.39-.1-1.84-.15-2.72.73.45,4.31,2.61,4.72,2.92,1.33,1,11.45-1.16,11.45-1.16,14.78-4.78,38.41-5,53.67-15.22C288.29,381,287.22,361.16,287.22,361.16Zm-93.16,28.39,4-26.32,1.59,24-.47,5.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.13,326.43l23.81-14s1.49-12.76,4.53-14.06c0,0,4.18-3.65,8.93-2.93,2.72.4,4.73-3,6.27-8.92,0-11.71-.16-26.66-.28-36-1-4.61-2.08-8.35-2.44-9.81L219.73,236s-2.4-8.1-14.74-9.91-25.57,11.42-27.08,20.43,7.22,18.62,3.91,23.73-17.15,12.61-20.76,21.32-2.71,14.72-2.71,14.72,9.93,14.11,7.22,18.92-18.65,9.31-18.35,23.43c.28,13.08,13.23,22.29,27.58,24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.18,238.41s-8.5-9.74-19.21-6.6-14.81,14.47-12.6,20.13,7.24,10.37,3.46,18.86-13.23,9.75-18,19.5-3.46,12.9-3.46,12.9",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48492790893308585px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.51,246.59s-7.87.94-7.87,6,4.41,7.54,5,13.83-1.26,8.81-6,16.67-5,11.95-1.57,17.3,5.67,14.15,1.26,17.29",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48492790893308585px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.4,240.3s-9.45-5-17-.31,2.52,14.15,3.78,22.95-5,15.1-13.54,24.53a26.42,26.42,0,0,0-6.3,21.07",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48492790893308585px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.7,319.55s2.2,4.71-3.79,11-18.9,7.87-22,17.3S156,362.32,156,362.32",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48492790893308585px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.67,288.6s.66,12.64,1.33,15.95,3.34,15.13,4.35,25.57a85.42,85.42,0,0,0,3,16s8.09,31.42,8.57-8.05c.17-13.92-1.33-35.8-1.33-35.8l.66-6.63",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.2,296.68,226,304.55l-.78-13.29S233.37,296.08,238.2,296.68Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.30000000000000004,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.61,302.23s-.4,22.56-1.5,32.1a45.16,45.16,0,0,0,1.84,18S242.48,317.43,240.61,302.23Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.30000000000000004,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M224.67,288.6s.66,12.64,1.33,15.95,3.34,15.13,4.35,25.57a85.42,85.42,0,0,0,3,16s8.09,31.42,8.57-8.05c.17-13.92-1.33-35.8-1.33-35.8l.66-6.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.87 341.56 213.76 346.08 227.64 359.63 215.87 341.56",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.87 341.56 213.76 346.08 227.64 359.63 215.87 341.56",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.7,351.55s4.64-10.72,6.1-8.28-7.81,12.91-4.15,14.37,9-3.9,7.32.48-4.63,9.5-4.63,11.7,1,23.87,1,23.87l.25,1.46-2.93,2s-3.17-3.17-3.17-5.85-.49-13.4-.49-15.83-1.14-11-1.14-11Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.7,351.55s4.64-10.72,6.1-8.28-7.81,12.91-4.15,14.37,9-3.9,7.32.48-4.63,9.5-4.63,11.7,1,23.87,1,23.87l.25,1.46-2.93,2s-3.17-3.17-3.17-5.85-.49-13.4-.49-15.83-1-11.6-1-11.6Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.83,294.83s-6.8,1.43-9.13,6.74-2.65,17.57-2.32,20.88a57.81,57.81,0,0,1,0,8l9.3-3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.11,303.25a12.31,12.31,0,0,0-7.64,2.89c-3.93,3.09-4.34,8.66-4.34,8.66s-1.24-6.6,1.24-12.37,9.46-7.6,9.46-7.6Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.30000000000000004,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M224.83,294.83s-6.8,1.43-9.13,6.74-2.65,17.57-2.32,20.88a57.81,57.81,0,0,1,0,8l9.3-3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,328.09l-10.29,11.6s7.64,11.93,11.29,15.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.24,353.94l5.31-20.22-9.3-7,7.31-2.32-6-20.55s-1.11-5.16-5-6.82",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,318.14s3.32,4,7,3.32,3.65-2.65,3.65-2.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-7--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.51,322.32s-5.37,5.85-5.13,7.31,6.59,4.14,5.13,5.84-5.13-2.43-5.86-1.7S177.5,380.29,178.72,381s4.15-1.95,4.88-.24-12.2,6.57-9.52,8,9.27-1.71,8-1.22-4.88,5.11-3.9,7.06,11.43,11.83,11.43,11.83a2.57,2.57,0,0,0-1.43,3.27,5.54,5.54,0,0,0,2,3.17s-2.8-2.31-3.23.19a25.81,25.81,0,0,0-.43,3.95l-6.85-6.78c-5.58-5.68-10.12-11-11.46-15.57,0,0-.24.67,1.23-4.69s16.1-51.15,16.1-51.15,3.31-10.78,4.58-12.45S197.51,322.32,197.51,322.32Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.51,322.32s-5.37,5.85-5.13,7.31,6.59,4.14,5.13,5.84-5.13-2.43-5.86-1.7S177.5,380.29,178.72,381s4.15-1.95,4.88-.24-12.2,6.57-9.52,8,9.27-1.71,8-1.22-4.88,5.11-3.9,7.06,11.43,11.83,11.43,11.83a2.57,2.57,0,0,0-1.43,3.27,5.54,5.54,0,0,0,2,3.17s-2.8-2.31-3.23.19-.65,4.14-.65,4.14l-6.63-7c-6.92-6.91-11.2-12.36-11.46-15.57,0,0-.81,1.52,1.23-4.69,1.73-5.28,16.1-51.15,16.1-51.15s3.31-10.78,4.58-12.45S197.51,322.32,197.51,322.32Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.53 315.66 209.53 334.33 221.3 331.32 225.22 326.8 213.15 329.21 213.94 312.38 209.53 315.66",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.53 315.66 209.53 334.33 221.3 331.32 225.22 326.8 213.15 329.21 213.94 312.38 209.53 315.66",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.05,312.18s-21.92,12.26-22.92,14.25-21.58,64-21.91,68.29,16.27,20.55,16.27,20.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.76,
    y1: 343.34,
    x2: 194.12,
    y2: 389.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 201.42,
    y1: 340.68,
    x2: 202.42,
    y2: 336.04,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.19,391.74s4.32-6,10.63-5.64,15.6,9.28,15.6,9.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.18,384.77a8.33,8.33,0,0,1,10.3-.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,398.58a3.54,3.54,0,0,0-5-2.75,2.64,2.64,0,0,0-1.45,2.17c-.37,3.65,1.87,12.62,4.87,12C208.91,409.44,208.83,404.72,208,398.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.32,401.23a3.54,3.54,0,0,0-5-2.74,2.61,2.61,0,0,0-1.45,2.16c-.37,3.65,1.87,12.62,4.87,12C202.27,412.09,202.19,407.38,201.32,401.23Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.22,407.91a3.55,3.55,0,0,0-5.56-1.42,2.61,2.61,0,0,0-.87,2.46c.54,3.62,4.94,11.81,7.67,10.42C198.81,418.17,197.51,413.33,195.22,407.91Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.92,414.31a2.64,2.64,0,0,0-4.15-1.06,2,2,0,0,0-.66,1.84c.41,2.71,3.69,8.79,5.74,7.78C193.61,422,192.68,418.61,190.92,414.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.51,401s2.6,2.81,4.53,3.41c1.59.49,9.86-1,9.86-1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.35,409.64s-5.31,1.32-9,2-7.64,1-7.64,1-2.66,3.32-4.65,3.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.75,309s16.79,10.24,20.14,13.58S286,357.24,286,357.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.71,
    y1: 331.35,
    x2: 270.47,
    y2: 358.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.47 355.23 268.13 335.06 278.47 357.84 270.94 358.18 270.47 355.23",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.47 355.23 268.13 335.06 278.47 357.84 270.94 358.18 270.47 355.23",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "206.53 345.29 200.03 355.96 205.54 351.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.22,364.52s1.35,19.82,1.35,22.52-.38,6.26-.38,6.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.05,265.1l0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.68,234.94s-9.63,5.63-10.29,13.92a51.24,51.24,0,0,0,1.66,16.24s-3-2.65-3.32,3.32,4.65,10.6,6.64,10.6h2s4.43,9.1,9.75,13.41,10.51,4.5,14.16,3.17,10.63-7.29,11.3-15.25,0-21.22-.67-29.5-2.32-14.26-11.29-17.24S225.33,232.61,220.68,234.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-8--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.05,265.1s-3-2.65-3.32,3.32,4.65,10.6,6.64,10.6h2s4.43,9.09,9.75,13.41L229.4,294a17.25,17.25,0,0,0,2.43,1.22c-1.79-2.2-5.68-7.27-7.51-11.83-2.42-6-3-18.67-2.42-26.8s4.83-11.45,4.83-11.45l-6-.3c-.89,0-5.54,6.92-10.26,10.89Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.30000000000000004,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.68,234.94s-9.63,5.63-10.29,13.92a51.24,51.24,0,0,0,1.66,16.24s-3-2.65-3.32,3.32,4.65,10.6,6.64,10.6h2s4.43,9.1,9.75,13.41,10.51,4.5,14.16,3.17,10.63-7.29,11.3-15.25,0-21.22-.67-29.5-2.32-14.26-11.29-17.24S225.33,232.61,220.68,234.94Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.06,265.37s2.78-4.75,5.55-2l2,9.43-4,.82.38,5.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 230.12,
    cy: 265.37,
    rx: 5.94,
    ry: 5.93,
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 230.12,
    cy: 265.37,
    rx: 5.94,
    ry: 5.93,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1668926417879113px",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.09,264.18a5.95,5.95,0,1,0-6,5.94A5.94,5.94,0,0,0,255.09,264.18Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.09,264.18a5.95,5.95,0,1,0-6,5.94A5.94,5.94,0,0,0,255.09,264.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.1668926417879113px",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 224.18,
    y1: 265.37,
    x2: 212.29,
    y2: 266.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.28,257.44a6,6,0,0,1,5.87-2.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.75,254.93a5,5,0,0,1,6.09,1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.9,250.85c-.66-8.29-2.32-14.26-11.29-17.24s-15.28-1-19.93,1.33c0,0-9.63,5.63-10.29,13.92a51.24,51.24,0,0,0,1.66,16.24s2.66,2.65,3.32-1-1.33-9.62,8-16.58,22.58-3.64,27.23,3a6.46,6.46,0,0,1,1.39,1.54C252,251.94,251.91,251,251.9,250.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.78,287.64s-8-1.32-14,2.66a10.72,10.72,0,0,0-4.65,10.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.51,288.31s-4,4.64-4,8.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6,269.41s4,24.2,7.64,31.49,14,14.26,21.92,17.57,45.16,8.62,46.49,8.29-6.31-7.29-4.65-15.91c.83-4.28,6.64-8.62,6.64-8.62s-16.27-7-22.58-9.61-13.28-5-13.28-5-9-8.28-13.28-11.93a136.37,136.37,0,0,0-12.29-8.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.41,314.31l4.34,5.4a24,24,0,0,0,2.8,2.21c1.3.7,2.42,2.82.63,3.33a5.49,5.49,0,0,1-4.81-.89l-4.22-3.09-3.53-3.19,2.56-4.6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.64,302.23s10.3,2.32,13.62,3,20.26,3.65,22.58,4.64,9.63,1.33,9.3,4.31-3.32,2.32-5.64,2-9.64-1.65-9.64-1.65,2.33,4.31,1.67,5.3-15.61,6.3-18.6,6.3-5-5.31-6.31-7l-4-5-8-3.64",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.86,
    y1: 314.5,
    x2: 170.54,
    y2: 311.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.65,326.76a15.44,15.44,0,0,0,5-12.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.25,
    y1: 318.47,
    x2: 160.91,
    y2: 324.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.89,
    y1: 315.82,
    x2: 167.55,
    y2: 322.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.66 364.22 228.66 442.12 332.6 436.16 332.6 358.92 228.66 364.22",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.6 358.92 327.28 355.93 224.34 360.91 224.34 436.82 228.66 442.12 228.66 364.22 332.6 358.92",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 224.34,
    y1: 360.91,
    x2: 228.65,
    y2: 364.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.17 409.64 270.17 462.35 298.73 460.36 298.73 407.32 270.17 409.64",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "269.28 439.48 269.28 409.64 298.73 407.32 298.81 437.63",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "270.17 462.35 255.22 449.09 270.17 448.42",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.05,413.64l94.45,9.46s-3.62-2.91-2.21-3.19c2.68-.52,6.65-.88,6.65-.88l-8.33-8.78-90.56,3.39",
    style: {
      fill: "#10A7D0",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.05,413.64l94.45,9.46s-3.62-2.91-2.21-3.19c2.68-.52,6.65-.88,6.65-.88l-8.33-8.78-90.56,3.39",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.68,
    y1: 410.29,
    x2: 32.28,
    y2: 415.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 331.89,
    y1: 407.12,
    x2: 431.25,
    y2: 468.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.28 422.56 99.27 428.91 132.78 464.1 188.84 457.17 151.28 422.56",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.28 422.56 99.27 428.91 132.78 464.1 188.84 457.17 151.28 422.56",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.11 436.41 144.34 430.64 177.86 464.67 124.69 472.17 98.11 436.41",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.28,467.22a.3.3,0,0,1,0-.6l42.52-5.47a.32.32,0,0,1,.34.26.3.3,0,0,1-.27.34l-42.51,5.47Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.91,464.38a.3.3,0,0,1,0-.6l42.52-5.47a.3.3,0,0,1,.08.6L124,464.38Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.55,461.54a.3.3,0,0,1-.3-.27.31.31,0,0,1,.26-.34L164,455.46a.33.33,0,0,1,.34.27.3.3,0,0,1-.27.33l-42.51,5.48Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.18,458.69a.3.3,0,0,1,0-.6l42.52-5.47a.31.31,0,0,1,.34.26.3.3,0,0,1-.26.34l-42.52,5.47Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.82,455.85a.3.3,0,0,1-.3-.26.3.3,0,0,1,.26-.34l42.52-5.47a.31.31,0,0,1,.34.26.3.3,0,0,1-.27.34l-42.51,5.47Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.45,453a.3.3,0,0,1-.3-.27.32.32,0,0,1,.26-.34l42.52-5.47a.31.31,0,0,1,.34.27.3.3,0,0,1-.26.33L114.49,453Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.09,450.16a.3.3,0,0,1-.3-.26.3.3,0,0,1,.26-.34l42.52-5.47a.32.32,0,0,1,.34.26.3.3,0,0,1-.27.34l-42.51,5.47Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.72,447.32a.3.3,0,0,1,0-.6l42.52-5.47a.3.3,0,0,1,.08.6l-42.52,5.47Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.36,444.48a.3.3,0,0,1-.3-.27.31.31,0,0,1,.26-.34l42.52-5.47a.32.32,0,0,1,.34.27.3.3,0,0,1-.27.33l-42.51,5.48Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,441.63a.3.3,0,0,1,0-.6l42.52-5.47a.31.31,0,0,1,.34.26.3.3,0,0,1-.26.34L105,441.63Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.28,467.22a.3.3,0,0,1,0-.6l42.52-5.47a.32.32,0,0,1,.34.26.3.3,0,0,1-.27.34l-42.51,5.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.91,464.38a.3.3,0,0,1,0-.6l42.52-5.47a.3.3,0,0,1,.08.6L124,464.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.55,461.54a.3.3,0,0,1-.3-.27.31.31,0,0,1,.26-.34L164,455.46a.33.33,0,0,1,.34.27.3.3,0,0,1-.27.33l-42.51,5.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.18,458.69a.3.3,0,0,1,0-.6l42.52-5.47a.31.31,0,0,1,.34.26.3.3,0,0,1-.26.34l-42.52,5.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.82,455.85a.3.3,0,0,1-.3-.26.3.3,0,0,1,.26-.34l42.52-5.47a.31.31,0,0,1,.34.26.3.3,0,0,1-.27.34l-42.51,5.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.45,453a.3.3,0,0,1-.3-.27.32.32,0,0,1,.26-.34l42.52-5.47a.31.31,0,0,1,.34.27.3.3,0,0,1-.26.33L114.49,453Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.09,450.16a.3.3,0,0,1-.3-.26.3.3,0,0,1,.26-.34l42.52-5.47a.32.32,0,0,1,.34.26.3.3,0,0,1-.27.34l-42.51,5.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.72,447.32a.3.3,0,0,1,0-.6l42.52-5.47a.3.3,0,0,1,.08.6l-42.52,5.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.36,444.48a.3.3,0,0,1-.3-.27.31.31,0,0,1,.26-.34l42.52-5.47a.32.32,0,0,1,.34.27.3.3,0,0,1-.27.33l-42.51,5.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,441.63a.3.3,0,0,1,0-.6l42.52-5.47a.31.31,0,0,1,.34.26.3.3,0,0,1-.26.34L105,441.63Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M150,245.87s8,2.66,10,6S167.14,273,167.14,273",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9698569847588134px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg15);
export default __webpack_public_path__ + "static/media/img15.7a656e58f0456d7ed32ab14fd3b1bc37.svg";
export { ForwardRef as ReactComponent };